export enum CmpConfigVendorListDisplayMode {
    CONDENSED = "CONDENSED",
    EXPANDED = "EXPANDED"
}

export const CMP_CONFIG_DISPLAY_MODES = [
    CmpConfigVendorListDisplayMode.CONDENSED,
    CmpConfigVendorListDisplayMode.EXPANDED
];
